import { Video } from './component';
import gsap from 'gsap';
import { ev, isTablet, isMobile } from '../../../js/utils';
import $ from 'jquery';

import initMap from '../quiz/map';
import DragHandler from './dragHandler';

import { premium, business } from './data';

export default () => {
	let mapInitialized = false;
	const videosContainer = document.querySelector('[data-videos]');
	if (!videosContainer) return;

	let isInitialized = false;

	const video1 = new Video({
		holder: document.querySelector('.video-story-1'),
		settings: {
			data: business,
			type: 'business',
		},
	});
	video1.init();

	const video2 = new Video({
		holder: document.querySelector('.video-story-2'),
		settings: {
			autoplay: false,
			data: premium,
			type: 'premium',
		},
	});
	video2.init();

	video1.player.on('volumechange', (event) => {
		const instance = event.detail.plyr;

		video2.player.muted = instance.muted;
	});

	video2.player.on('volumechange', (event) => {
		const instance = event.detail.plyr;

		video1.player.muted = instance.muted;
	});

	let switcher = false;
	let currentVideo = video1;
	let nextVideo = video2;
	let currentVideoType = 'business';
	window.currentType = 'business';

	document.querySelectorAll('.plyr__video-wrapper').forEach((el, i) => {
		el.addEventListener('click', () => {
			nextVideo.player.currentTime = currentVideo.player.currentTime;

			currentVideoType = currentVideoType === 'business' ? 'premium' : 'business';
			window.currentType = currentVideoType;
			// console.log('currentVideoType', currentVideoType);

			document.querySelector('[data-videos]').classList.toggle('is-video-2');

			switcher = !switcher;

			$('.menu_items').toggleClass('order-switched', switcher);

			setTimeout(
				() => {
					if (!currentVideo.player.paused) nextVideo.player.play();
					currentVideo.player.pause();
					const currentVideoTemp = currentVideo;
					currentVideo = nextVideo;
					nextVideo = currentVideoTemp;

					if (isTablet) {
						currentVideo.dragHandler.updateUI();
						// currentVideo.dragHandler.updatePosition();
					}
				},
				isMobile ? 0 : 50,
			);

			document.body.dispatchEvent(
				new CustomEvent("data-analytics-nu", { detail: "2024-sia-video-toggle" })
			);
		});
	});

	document.addEventListener('initVideo', (e) => {
		//console.log('initVideo', isInitialized);
		if (isInitialized) {
			video1.player.play();
			return;
		}

		const isMuted = e.detail.muted;
		const autoplay = e.detail.autoplay;

		video1.initTimeline();
		video2.initTimeline();

		if (autoplay) video1.player.play();
		video1.player.muted = isMuted;

		isInitialized = true;
	});

	document.addEventListener('hideVideo', (e) => {
		hideVideo(e.detail?.isCulinary);
	});

	document.addEventListener('showVideo', (e) => {
		showVideo(e.detail);
	});

	document.addEventListener('pauseVideo', (e) => {
		currentVideo.player.pause();
	});

	document.addEventListener('resumeVideo', (e) => {
		currentVideo.player.play();
	});

	function hideVideo(isCulinary) {
		videosContainer.classList.add('is-hidden');
		currentVideo.player.pause();

		gsap.to(videosContainer, {
			opacity: 0,
			duration: 1,
			ease: 'power2.out',
			pointerEvents: 'none',
			onComplete: () => {
				gsap.set(videosContainer, {
					visibility: 'hidden',
				});
				if (!isCulinary) return;

				if (!mapInitialized) {
					initMap();
					mapInitialized = true;
					//console.log('showCulinary initMap');
				}
			},
		});

		ev('hideBurgerBtn', {});
		ev('hideCursor', {});
	}

	function showVideo(eventDetails) {
		// console.log('showVideo', eventDetails.currentArticle);
		if (eventDetails?.currentArticle && eventDetails.currentArticle != currentVideoType) {
			// currentVideoType = eventDetails.currentArticle;
			// 'business'
			$('.plyr__video-wrapper').eq(0).trigger('click');
		}
		// business currentVideoType
		gsap.set(videosContainer, {
			visibility: 'visible',
		});
		videosContainer.classList.remove('is-hidden');

		if (!eventDetails?.paused) currentVideo.player.play();
		if (!eventDetails?.muted) {
			currentVideo.player.volume = 1;
			currentVideo.player.muted = false;
		}
		gsap.to(videosContainer, {
			opacity: 1,
			duration: 1,
			ease: 'power2.out',
			pointerEvents: 'auto',
			onComplete: () => {
				if (eventDetails?.onComplete) eventDetails.onComplete();
			},
		});

		// ev('showCursor', {});
		ev('showBurgerBtn', {});
	}

	document.addEventListener('orientationchange', (e) => {
		const { orientation } = e.detail;

		if (orientation == 'landscape') {
			video1.player.pause();
			video2.player.pause();
		}
	});
};
